const type = 'SHOW_BLOCKED_MODAL_LOADING';

const showBlockedModalLoading = (data) => ({
  data,
  type,
});

export { type };
export default showBlockedModalLoading;
